export { NileSlider } from './nile-slider';